import * as React from 'react';
import { SVGProps } from 'react';

export const CustomerReceipt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.61557 1.61655C4.98283 1.24929 5.48094 1.04297 6.00033 1.04297H18.0003C18.5197 1.04297 19.0178 1.24929 19.3851 1.61655C19.7523 1.98381 19.9587 2.48192 19.9587 3.0013V22.0013C19.9587 22.3697 19.7475 22.7055 19.4155 22.8651C19.0834 23.0246 18.6893 22.9798 18.4017 22.7496L16.5714 21.2855L15.178 22.6789C14.8327 23.0242 14.283 23.0547 13.9017 22.7496L12.0003 21.2286L10.099 22.7496C9.71768 23.0547 9.16797 23.0242 8.82268 22.6789L7.4292 21.2855L5.59899 22.7496C5.31133 22.9798 4.91722 23.0246 4.58519 22.8651C4.25316 22.7055 4.04199 22.3697 4.04199 22.0013V3.0013C4.04199 2.48192 4.24832 1.98381 4.61557 1.61655ZM6.00033 2.95964C5.98927 2.95964 5.97868 2.96403 5.97086 2.97184C5.96305 2.97965 5.95866 2.99025 5.95866 3.0013V20.0074L6.90166 19.253C7.28297 18.9479 7.83268 18.9784 8.17797 19.3237L9.57145 20.7171L11.4017 19.253C11.7517 18.973 12.249 18.973 12.599 19.253L14.4292 20.7171L15.8227 19.3237C16.168 18.9784 16.7177 18.9479 17.099 19.253L18.042 20.0074V3.0013C18.042 2.99025 18.0376 2.97965 18.0298 2.97184C18.022 2.96403 18.0114 2.95964 18.0003 2.95964H6.00033Z"
      fill="#071114"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.04199 6.0013C8.04199 5.47203 8.47105 5.04297 9.00033 5.04297H15.0003C15.5296 5.04297 15.9587 5.47203 15.9587 6.0013C15.9587 6.53057 15.5296 6.95963 15.0003 6.95963H9.00033C8.47105 6.95963 8.04199 6.53057 8.04199 6.0013Z"
      fill="#071114"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.04199 10.0013C8.04199 9.47203 8.47105 9.04297 9.00033 9.04297H15.0003C15.5296 9.04297 15.9587 9.47203 15.9587 10.0013C15.9587 10.5306 15.5296 10.9596 15.0003 10.9596H9.00033C8.47105 10.9596 8.04199 10.5306 8.04199 10.0013Z"
      fill="#071114"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.04199 14.0013C8.04199 13.472 8.47105 13.043 9.00033 13.043H10.0003C10.5296 13.043 10.9587 13.472 10.9587 14.0013C10.9587 14.5306 10.5296 14.9596 10.0003 14.9596H9.00033C8.47105 14.9596 8.04199 14.5306 8.04199 14.0013Z"
      fill="#071114"
    />
  </svg>
);
export default CustomerReceipt;
